module.exports = __webpack_public_path__ + "img/20.9e894573.jpg";